module.exports = __webpack_public_path__ + "img/video-repeat.f56a3d78.jpg";